import React from 'react';
import { useIntl } from 'react-intl/dist';
import styled from 'styled-components';

const StyledHeading = styled.span`
    color: ${({ theme }) => theme.gray6};
    font-weight: normal;
`;

const StyledText = styled.span`
    color: ${({ theme }) => theme.gray2};
    text-align: left;
`;

const DetailedFields: React.FC<{ label: string; value: string; dataTestId: string; showColon?: boolean }> = ({
    label,
    value,
    dataTestId,
    showColon = false,
}) => {
    const intl = useIntl();

    return (
        <>
            <StyledHeading>
                {intl.formatMessage({ id: label })} {showColon ? ':' : ''}
            </StyledHeading>
            <StyledText data-testid={dataTestId}>{value}</StyledText>
        </>
    );
};

export default DetailedFields;
